import useAcOrBc from "./useAcOrBc";

const usePartialResults = ({ data, testType, ...rest }) => {
  const dataOfSameType = useAcOrBc(data, testType);
  return { data: dataOfSameType };
};

export default usePartialResults;
